import { Component } from "@angular/core"
import { ICellRendererAngularComp } from "ag-grid-angular"
import { ICellRendererParams } from "ag-grid-community"
import { MultiActionLink } from "src/app/model/result-grid/grid-multi-action-link"

@Component({
  selector: 'multi-action-link-cell-renderer',
  templateUrl: './multi-action-link-cell-renderer.component.html',
  styleUrls: ['./multi-action-link-cell-renderer.component.scss']
})

export class MultiActionLinkCellRendererComponent implements ICellRendererAngularComp {

  public params!: ICellRendererParams & {
    linkData: MultiActionLink
  };

  agInit(params: ICellRendererParams & {
    linkData: MultiActionLink
  }): void {
    this.params = params;
  }

  refresh(params: ICellRendererParams & {
    linkData: MultiActionLink
  }): boolean {
    this.params = params;
    return true;
  }

  public triggerAction(index: number, data: any) {
    this.params.linkData.actions[index].actionCallback(data);
  }
}
